export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14451.9a1e57f6.jpg";